import { render, staticRenderFns } from "./CellRendererCrewStatus.vue?vue&type=template&id=a020b8de&scoped=true"
import script from "./CellRendererCrewStatus.vue?vue&type=script&lang=js"
export * from "./CellRendererCrewStatus.vue?vue&type=script&lang=js"
import style0 from "./CellRendererCrewStatus.vue?vue&type=style&index=0&id=a020b8de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a020b8de",
  null
  
)

export default component.exports